// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.6.10-6UolF5LZuIaZoDlY8wmT/mode=imports,min/optimized/keen-slider.js'

class PushColours extends window.BAO.CustomElement() {
  static get styles () {
    return `
      :host {
        display: block;
      }
    `
  }

  static get requiredElements () {
    return ['slides']
  }

  connectedCallback () {
    super.connectedCallback()

    if (!this.els.slide?.elements) return

    this.classUp()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    const slider = new KeenSlider(this.els.slides.element, {
      selector: this.els.slide.selector,
      slides: {
        perView: 7,
      },
    })

    return slider
  }

  classUp () {
    if (!this.els.slides.element.classList.contains('keen-slider')) {
      this.els.slides.element.classList.add('keen-slider')
    }

    if (!this.els.slide.element.classList.contains('keen-slider__slide')) {
      this.els.slide.elements.forEach(el =>
        el.classList.add('keen-slider__slide'),
      )
    }
  }
}

if (!customElements.get('push-colours')) {
  customElements.define('push-colours', PushColours)
}
